import { React, models, kea, history, resources, selectores, componentToRx } from "app/main/std";

interface Props {
    go: string;
    title: string;
    icon: string;
}

export class LinkMenuIndice extends React.PureComponent<Props> {

    render() {
        const props = this.props;
        return (
            <h4 >
                <kea.Link iconClass={props.icon} onClick={() => history.go(this.props.go)}  >
                    {props.title}
                </kea.Link>
            </h4>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/menu/link.tsx